// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"24ef4f674ddec8da","5285":"117c7d654aa3ca65"}[chunkId] + ".css";
};